import React, { FC, Fragment } from 'react';
import { noop } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import AddPhotoAlternate from '@material-ui/icons/AddPhotoAlternate';

import { S3ObjectInput, S3VideoObjectInput } from 'api';
import { AspectRatios } from 'types/app';
import { IUploader, UploadDialog, Uploader, UploaderContentTypes, UploadInput } from 'components';

interface IProps {
  onSave?: () => void;
}

const useStyles = makeStyles({
  button: {
    alignItems: 'stretch',
    marginTop: 6,
    marginBottom: 6,
  },
});

const PhotoVideoUpload: FC<IProps> = ({ onSave }) => {
  const classes = useStyles();
  const { setFieldValue } = useFormikContext();
  const { t } = useTranslation();

  function handleSave(s3Object: S3ObjectInput | S3VideoObjectInput, type: UploaderContentTypes) {
    if (type === UploaderContentTypes.Video) {
      setFieldValue('content_object.media.video', s3Object);
      setFieldValue('content_object.photos', null);
    }

    if (type === UploaderContentTypes.Image || type === UploaderContentTypes.GIF) {
      setFieldValue('content_object.photos', [s3Object]);
      setFieldValue('content_object.media', null);
    }

    onSave();
  }

  return (
    <Uploader onSave={handleSave}>
      {(uploaderProps: IUploader) => (
        <Fragment>
          <UploadInput accept="video/*,image/*" onUpload={uploaderProps.onUpload}>
            <Button
              size="small"
              variant="contained"
              component="span"
              className={classes.button}
              startIcon={<AddPhotoAlternate />}>
              {t('posting:photoVideoUpload')}
            </Button>
          </UploadInput>
          <UploadDialog
            aspectRatio={AspectRatios.none}
            i18nKeyTitle="posting:photo"
            i18nKeyReplace="components:replaceImage"
            {...uploaderProps}
          />
        </Fragment>
      )}
    </Uploader>
  );
};

PhotoVideoUpload.defaultProps = {
  onSave: noop,
};

export default PhotoVideoUpload;
